import { render, staticRenderFns } from "./Quotations.vue?vue&type=template&id=80120814&scoped=true&"
import script from "./Quotations.vue?vue&type=script&lang=ts&"
export * from "./Quotations.vue?vue&type=script&lang=ts&"
import style0 from "./Quotations.vue?vue&type=style&index=0&id=80120814&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80120814",
  null
  
)

export default component.exports